module.exports = __webpack_public_path__ + "static/media/no_poster_album.8d55f821.jpg";